import { DisplayPosition } from '@/type/display-position';
import { getMaxLengthSetterSnippet } from '@/common/manager/setter-snippet';
// import { CnInput, componentMap as formComponentMap } from '@cainiaofe/cn-ui-m';
export default {
    position: [
        DisplayPosition.form,
        DisplayPosition.formDialog,
        DisplayPosition.filter,
        DisplayPosition.cnArrayTable,
    ],
    title: '文本输入框',
    componentName: 'CnInput',
    // component: CnInput,
    // formComponent: formComponentMap.CnInput,
    getFormItemDefaultProps: () => {
        return {};
    },
    getPrototypeList: () => {
        return [
            getMaxLengthSetterSnippet(),
            {
                name: 'addonAfter',
                title: '输入框后附加内容',
                display: 'inline',
                setter: 'CnI18nSetter',
            },
            {
                name: 'isPassword',
                title: '开启密码输入模式',
                display: 'inline',
                setter: 'BoolSetter',
            },
        ];
    },
    // formItemBeforeHandler: (formItem, config) => {
    //   if (formItem) {
    //     const componentProps = formItem['x-component-props'];
    //     if (componentProps) {
    //       componentProps.showLimitHint = true;
    //     }
    //   }
    // },
    // filterItemBeforeHandler: (filterItemProps, config) => {
    //   const { componentProps } = config || {};
    //   if (componentProps) {
    //     componentProps.showLimitHint = true;
    //   }
    // },
};
